import { FC, ReactElement } from 'react';
import { Col, Row } from '@base/lib/ThemeGrid';
import Image from '@base/lib/ThemeImage';

type ICardListProps = {
    list: Array<{
        icon: string;
        title: string;
        desc: string | ReactElement;
    }>;
};

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

export const CardList: FC<ICardListProps> = props => {
    const { list } = props;

    return (
        <Row gutter={isPhone ? 32 : 48} colsPerRow={isPhone ? 1 : 3}>
            {list.map(item => (
                <Col key={item.title}>
                    <div className="g-card">
                        <Image
                            src={item.icon}
                            width={32}
                            background={false}
                            fixed
                        />
                        <div className="g-card-title">{item.title}</div>
                        <div className="g-card-desc">{item.desc}</div>
                    </div>
                </Col>
            ))}
        </Row>
    )
};
